// extracted by mini-css-extract-plugin
export default {"featureItem":"FeatureItem_featureItem__J2MHS","featureEmoji":"FeatureItem_featureEmoji__SXQHt","featureTitle":"FeatureItem_featureTitle__tJkyY"};